// extracted by mini-css-extract-plugin
export default {"form":"ProjectForm_form__yUn-y","button":"ProjectForm_button__A-Kx+","formGroup":"ProjectForm_formGroup__NM7U6","textEditor":"ProjectForm_textEditor__UROxS"};